import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "react-axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

import ChimneyName from "~/Components/Elements/ChimneyName";
import InlineEdit from "~/Components/Elements/Forms/InlineEdit";
import { useUser } from "~/Context/userContext";
import { postMessageBoardCommentEdit } from "~/api/getMessageBoard";

const TrackComment = (props) => {
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(false);
  const { comment, addRe, isHome, type, highlight: highlightText } = props;
  const classNames = require("classnames");
  const isCommentSearchResult = type === "comment-search";

  const wrapperClass = classNames({
    "mb-thread-box": true,
    "mb-thread-type-home": isHome,
    "mb-thread-type-standard": !isHome,
    "mb-thread-type-comment-search": isCommentSearchResult,
  });

  function getHighlightedText(text, highlight) {
    // Split text on highlight term, include term itself into parts, ignore case
    var parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (
      "<span>" +
      parts
        .map((part) => (part.toLowerCase() === highlight.toLowerCase() ? '<span class="highlight">' + part + "</span>" : part))
        .join(" ") +
      "</span>"
    );
  }

  function createMarkup(text) {
    let htmlText = text;
    if (isCommentSearchResult && highlightText !== "") {
      htmlText = getHighlightedText(text, highlightText);
    }
    return { __html: htmlText };
  }

  function isEditable() {
    return comment.dir && userState.user && userState.user.dir === comment.dir;
  }

  const onSave = async (newValue) => {
    if (newValue === comment.message) return false;

    setLoading(true);
    const payload = {
      id: comment.id,
      message: newValue,
      chimdir_save: userState.user.dir,
    };
    await postMessageBoardCommentEdit(axios, payload);
    setLoading(false);
  };

  return (
    <div className={wrapperClass}>
      <Row noGutters>
        <Col xs={12} md={2} className="mb-thread-box-left">
          <div>
            {comment.user_type === "chim" && (
              <React.Fragment>
                <div className={!comment.most_recent_img ? "chim-mb-name no-avatar" : "chim-mb-name"}>
                  <div>
                    <ChimneyName user={comment} />
                  </div>
                  {comment.aka && <div className="aka">AKA: {comment.aka}</div>}
                </div>
                {comment.most_recent_img && (
                  <div className="avatar">
                    <Link to={`/profile/${comment.dir}`}>
                      <img
                        src={comment.most_recent_img}
                        alt={comment.most_recent_title}
                        title={comment.most_recent_title}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                )}
                {comment.vacation && comment.vacation !== "" && <div className="status">Status: {comment.vacation}</div>}
              </React.Fragment>
            )}
            {comment.user_type === "user" && (
              <React.Fragment>
                <div className="author">
                  <div>
                    <Link to={`/user/${comment.dir}`}>{comment.full_name}</Link>
                  </div>
                </div>
                <div className="avatar">
                  <Link to={`/user/${comment.dir}`}>
                    {comment.avatar && <img src={comment.avatar} alt="" className="img-fluid" />}
                    {!comment.avatar && (
                      <img
                        src="//www.dreamchimney.com/tracks/assets/avatar.png"
                        alt="Guest Avatar"
                        style={{ boxShadow: "none" }}
                        className="img-fluid"
                      />
                    )}
                  </Link>
                </div>
              </React.Fragment>
            )}
            {comment.user_type === "anon" && (
              <div>
                <div className="author">
                  <div>{comment.full_name}</div>
                </div>
                <div className="avatar anon">
                  <img
                    src="//www.dreamchimney.com/tracks/assets/avatar.png"
                    alt="Guest Avatar"
                    style={{ boxShadow: "none" }}
                    className="img-fluid"
                  />
                </div>
              </div>
            )}
          </div>
        </Col>
        <Col xs={12} sm={12} md={10} className="mb-thread-box-right">
          {comment.icon && (
            <span className={`icon ${isEditable() ? `push-down` : null}`}>
              <img src={`//www.dreamchimney.com/tracks/images/icons/${comment.icon}`} alt="Hugest Thanks" />
            </span>
          )}
          {addRe && (
            <div className="header-tab">
              <CommentSubject comment={comment} />
            </div>
          )}
          {isHome && (
            <div className="header-user">
              <ChimneyName user={comment} />
            </div>
          )}
          <div className="comment-message">
            {(isEditable() && <InlineEdit text={comment.message} loading={loading} onSave={onSave} />) || (
              <div dangerouslySetInnerHTML={createMarkup(comment.message)} />
            )}
          </div>
        </Col>
        <Col xs={12} className="mb-thread-box-footer">
          <Row>
            <Col xs={2} sm={6}>
              <span></span>
            </Col>
            <Col xs={10} sm={6}>
              <div className="dateTime">
                Posted: {comment.date} at {comment.time}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

TrackComment.propTypes = {
  isHome: PropTypes.bool,
  comment: PropTypes.object.isRequired,
  addRe: PropTypes.bool,
  highlight: PropTypes.string,
};

TrackComment.defaultProps = {
  highlight: "",
  isHome: false,
  addRe: false,
};

const CommentSubject = ({ comment }) => {
  return (
    <span>
      {comment.subject === "" && (
        <Link to={`/message-board/topic/${comment.thread_id}`}>
          RE: "{comment.title}" by {comment.artist}
        </Link>
      )}
      {comment.subject !== "" && <Link to={`/message-board/topic/${comment.thread_id}`}>{comment.subject}</Link>}
    </span>
  );
};

export default TrackComment;
